module.exports = __webpack_public_path__ + "img/bg-black.815df261.jpg";